<template>
  <div class="footer_box">
    <div class="foot_cont">
      <div class="cont_menu">
        <p class="logo"><img src="@/assets/deep_logo.png" alt="" /></p>
        <div class="menu_cont">
          <ul>
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/newsList">新闻资讯</router-link></li>
            <li v-if="!userInfo" @click="loginBtn()"><a>登录</a></li>
          </ul>
          <ul>
            <li @click="$router.push('/claimTrain')">项目资源清单</li>
            <li @click="$router.push('/claimStatistics')">统计汇总表</li>
            <li @click="$router.push('/claimDemand')">各地企业技术需求调查表</li>
          </ul>
        </div>
      </div>
      <div class="tips_text flex">
        <p>主办单位：广东省总工会</p>
        <!-- <p>承办单位：中华全国总工会经济技术部</p> -->
      </div>
      <div class="code_text">
        Copyright © 2023 kjcxchina.com All Rights Reserved | 京ICP备18023227号-1
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "header_box",
  data() {
    return {
      userInfo: "",
      maskState: true,
      fileInfo: {
        url: "",
        name: "",
      },
      fileCont: {
        type: 1,
        file: "",
      },
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    ...mapMutations(["ShowLoginModal", "ShowTipModal", "ClearUserInfo"]), //登录弹窗
    loginBtn() {
      this.ShowLoginModal();
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/utils/common.scss";
.footer_box {
  padding: 52px 0 33px;
  background: #262626;
  .foot_cont {
    width: 1200px;
    margin: 0 auto;
    .cont_menu {
      display: flex;
      padding-bottom: 53px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      p.logo {
        img{
          width: 100%;
          height: 36px;
        }
      }
      .menu_cont {
        margin-left: 52px;
        display: flex;
        padding-left: 80px;
        border-left: 1px solid rgba(255, 255, 255, 0.1);

        ul {
          margin-right: 124px;
          li {
            margin-bottom: 14px;
            font-size: 15px;
            color: #ffffff;
            a {
              font-size: 15px;
              color: #ffffff;
            }
          }
          li:last-child {
            margin-bottom: 0;
          }
        }
        ul:last-child {
          margin-right: 0;
        }
      }
    }
    .tips_text {
      margin-top: 13px;
      p {
        font-size: 13px;
        color: #ffffff;
        margin-right: 74px;
      }
    }
    .code_text {
      margin-top: 13px;
      padding-top: 13px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      font-size: 13px;
      color: #ffffff;
    }
  }
}
</style>
